<template>
  <div class="navbar">
    <div class="left-panel">
      <button type="button" class="hamburger" @click="toggleSidebar">
        <i :class="sidebar.opened ? 'el-icon-s-fold' : 'el-icon-s-unfold'" />
      </button>
      <div class="crumb-wrap">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item v-for="(item, index) in breadcrumbs" :key="item.path">
            <span v-if="index === breadcrumbs.length - 1" class="crumb-current">{{ item.meta.title }}</span>
            <router-link v-else :to="item.path">{{ item.meta.title }}</router-link>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="right-panel">
      <el-tooltip content="刷新当前页" placement="bottom" :open-delay="300">
        <button type="button" class="icon-btn" :class="{ spinning: refreshing }" @click="refreshPage">
          <i class="el-icon-refresh" />
        </button>
      </el-tooltip>
      <div class="brand-chip">{{ appName }}</div>
      <el-dropdown trigger="click" @command="handleCommand">
        <span class="user-dropdown">
          <el-avatar :size="34" icon="el-icon-user-solid" class="avatar" />
          <span class="username">{{ userInfo.nickname || userInfo.username || '管理员' }}</span>
          <i class="el-icon-arrow-down" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Navbar',
  data() {
    return { refreshing: false }
  },
  computed: {
    ...mapGetters(['appName']),
    sidebar() {
      return this.$store.state.app.sidebar
    },
    userInfo() {
      return this.$store.getters.userInfo
    },
    breadcrumbs() {
      const matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      return matched
    }
  },
  methods: {
    toggleSidebar() {
      this.$store.dispatch('app/toggleSidebar')
    },
    refreshPage() {
      if (this.refreshing) return
      const { name, path, meta, query } = this.$route
      if (!path || path.indexOf('/redirect') === 0) return
      this.refreshing = true
      const view = { name, path, meta }
      this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        this.$nextTick(() => {
          this.$router.replace({ path: '/redirect' + path, query }).catch(() => {})
          setTimeout(() => { this.refreshing = false }, 400)
        })
      }).catch(() => {
        this.refreshing = false
      })
    },
    handleCommand(cmd) {
      if (cmd === 'logout') {
        this.$confirm('确定退出登录吗？', '提示', { type: 'warning' }).then(() => {
          this.$store.dispatch('user/logout').then(() => {
            this.$router.push('/login')
          })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: $navbar-height;
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(22, 93, 255, 0.06);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 22px;
}

.left-panel {
  display: flex;
  align-items: center;
  min-width: 0;
}

.hamburger,
.icon-btn {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 10px;
  background: #f2f5fb;
  color: #4e5969;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, color 0.2s;

  i { font-size: 18px; }

  &:hover {
    background: rgba($primary, 0.1);
    color: $primary;
  }
}

.hamburger {
  margin-right: 14px;
}

.icon-btn.spinning i {
  animation: spin 0.6s linear;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.crumb-wrap {
  min-width: 0;
}

.crumb-current {
  color: #1d2129;
  font-weight: 600;
}

.right-panel {
  display: flex;
  align-items: center;
  gap: 14px;
}

.brand-chip {
  display: none;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba($primary, 0.08);
  color: $primary;
  font-size: 12px;
  font-weight: 600;
}

@media (min-width: 1100px) {
  .brand-chip {
    display: inline-flex;
  }
}

.user-dropdown {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #4e5969;
  padding: 4px 8px 4px 4px;
  border-radius: 999px;
  transition: background 0.2s;

  &:hover {
    background: #f2f5fb;
  }

  .avatar {
    background: linear-gradient(135deg, $primary, $primary-light);
  }

  .username {
    margin: 0 8px;
    font-size: 14px;
    font-weight: 500;
    color: #1d2129;
  }
}
</style>
